import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { FormlyModule } from '@ngx-formly/core';

import { HiddenFieldComponent } from './hidden.component';

import { ISPFieldType } from '../../model';

/**
 * Hidden input component
 */
@NgModule({
  declarations: [HiddenFieldComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormlyModule.forChild({
      types: [
        {
          name: ISPFieldType.Hidden,
          component: HiddenFieldComponent,
        },
      ],
    }),
  ],
})
export class HiddenFieldModule {}
